import { translate as $t } from '../i18n';
import optional from "./Optional";
import {date_format} from "./DateTimeHelper";

const settings = window.settings || {};

export const getThousandSeparator = () => {
    return settings.thousand_separator ? settings.thousand_separator : ' ';
}

export const getDecimalSeparator = () => {
    return settings.decimal_separator ? settings.decimal_separator : '.';
}

export const getNumberOfDecimal = () => {
    return settings.number_of_decimal ? settings.number_of_decimal : 0
}

export const numberFormatter = number => {
    if (number && (String(number).indexOf('.') > -1)) {
        number = number.toFixed(getNumberOfDecimal())
    }
    if (!isNaN(parseFloat(number))) {
        let parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, getThousandSeparator());
        return parts.join(getDecimalSeparator());
    }
    return 0;
}

export const configFormatter = (format) => {
    return {
        id: format,
        value: $t(format)
    }
};

const currencySymbols = window.currencies || {};

/**
 * Resolve the display symbol for a currency code (per-employee salary currency),
 * falling back to the company-wide currency_symbol setting when none is given.
 */
export const currencySymbol = (code = null) => {
    if (!code) return optional(settings, 'currency_symbol');
    return currencySymbols[code] || code;
}

/**
 * @param amount   already number-formatted amount
 * @param currency optional ISO code (e.g. "EUR"); null => company default symbol
 */
export const formatCurrency = (amount, currency = null) => {
    return $t(`format_${optional(settings, 'currency_position')}`,
        {
            symbol: currencySymbol(currency),
            amount: amount
        })
}


